import React, { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Header from "../Pages/Administration/Layout/Header";
import Sidebar from "../Pages/Administration/Layout/Sidebar";
import "../assets/css/Admin/main.css";
import useBreakPoints from "../hooks/useBreakPoints";
import MobileSidebar from "../Pages/Administration/Layout/MobileSidebar";

const AdminAuthProtected = () => {
  const { adminToken, theme, isMenuExpanded } = useContext(MyContext);
  const { isLaptop } = useBreakPoints();
  const location = useLocation();

  useEffect(() => {
    // Only load CSS if the route contains 'administration'
    if (location.pathname.includes("administration")) {
      // Create and append CSS links
      const cssLinks = [
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/libs/node-waves/node-waves.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/libs/pickr/pickr-themes.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/css/core.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/css/demo.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/libs/apex-charts/apex-charts.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/libs/swiper/swiper.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/libs/datatables-bs5/datatables.bootstrap5.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/libs/datatables-responsive-bs5/responsive.bootstrap5.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/fonts/flag-icons.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/css/pages/cards-advance.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/css/pages/page-auth.css",
        "https://fonts.googleapis.com",
        "https://fonts.gstatic.com",
        "https://fonts.googleapis.com/css2?family=Public+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&ampdisplay=swap",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/vendor/fonts/iconify-icons.css",
        "https://demos.pixinvent.com/vuexy-html-admin-template/assets/img/favicon/favicon.ico",
      ];

  
      const linkElements = cssLinks.map((href) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        document.head.appendChild(link);
        return link;
      });

      // Cleanup function to remove CSS links when component unmounts
      return () => {
        linkElements.forEach((link) => {
          document.head.removeChild(link);
        });
      };
    }
  }, [location.pathname]); // Add location.pathname to dependency array

  if (!adminToken) {
    return <Navigate to="/administration" replace />;
  }

  console.log(adminToken, "adminToken");

  // Render child routes here using Outlet
  return (
    <div
      data-bs-theme={theme === "dark" ? "dark" : "light"}
      data-assets-path="../../assets/"
      data-template="horizontal-menu-template"
      className="layout-compact layout-menu-fixed body"
    >
      <div
        className={`layout-wrapper layout-navbar-full layout-horizontal layout-without-menu ${
          isMenuExpanded ? "layout-menu-expanded" : ""
        }`}
        id="pageWrapper"
      >
        <div className="layout-container">
          <Header />
          <div className="content-wrapper w-100">
            {isLaptop ? <MobileSidebar /> : <Sidebar />}
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

const AccessRoute = ({ component: Component }) => {
  // Render the passed component as a JSX element
  return <>{Component}</>;
};

export { AdminAuthProtected, AccessRoute };
